module.exports = __webpack_public_path__ + "img/stone-path-outer-corner.4f29e1ba.png";